<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-回访-添加
    -->
    <el-dialog
    title="修改类型"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true" 
    width="50%"
  >
  <div class="active-basic">
  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改类型</div>




      <el-form-item label="类型名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入类型名称" class="max-w460"></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</div>
 </el-dialog>
  
</template>

<script>
import projectApi from '@/api/project.js';

export default {
  components: {

  },
  data() {
    return {

      /*form表单数据*/
      form: {
        name: '',


      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
      },
      dialogVisible:false,

    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","rule_type_id"],
  methods: {
       
  
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      console.log("self.rule_type_id",self.rule_type_id)
      projectApi.getType({rule_type_id: self.rule_type_id},true).then(res => {
          self.form = res.data.detail;
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.rule_type_id = self.rule_type_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          projectApi.editType(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
       /*关闭弹窗*/
       dialogFormVisible(result) {
      this.$emit("close", {});
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
  }
};
</script>

<style  lang="scss">
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.active-basic .ad-picture {
  width: 124px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/project/type/edit.vue